import Vue from 'vue'
import App from './App.vue'
import './assets/text.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; 
import router from './router' // 这里引入了路由对象
import VueLazyload from 'vue-lazyload'
Vue.use(ElementUI);
Vue.use(VueLazyload, {
   loading: require('./assets/loading.jpg'),
  error: require('./assets/errorImg.jpg'),
  preLoad: 1.3, // 预加载高度的比例
  attempt: 3 // 尝试加载次数
})

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router, // 在Vue实例中使用路由对象
}).$mount('#app')
